import React, { useState } from 'react';
import { useEvents } from '../contexts/EventContext';
import { useSport } from '../contexts/SportContext';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

const EventCreationModal = ({ coords, onClose }) => {
    const { createEvent } = useEvents();
    const { sportTypes } = useSport();
    const { user } = useAuth();
    const { t } = useTranslation();

    const favoriteSportName = sportTypes[user?.favorite_sport]?.name || 'Vibe';

    const getRoundedTime = () => {
        const now = new Date();
        now.setHours(now.getHours() + 3);
        now.setMinutes(0);
        now.setSeconds(0);
        const offset = now.getTimezoneOffset();
        const adjustedDate = new Date(now.getTime() - (offset * 60 * 1000));
        return adjustedDate.toISOString().slice(0, 16);
    };

    const [formData, setFormData] = useState({
        title: t('default_event_title', { sportName: favoriteSportName }),
        event_date: getRoundedTime(),
        max_participants: '',
        description: '',
        latitude: coords.lat,
        longitude: coords.lng
    });
    const [isPublic, setIsPublic] = useState(true);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = e => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async e => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const eventData = {
            ...formData,
            max_participants: formData.max_participants || null,
            is_public: isPublic,
            sport_type: user?.favorite_sport
        };

        console.log('Creating event with data:', eventData);

        try {
            const response = await createEvent(eventData);
            console.log('Event created successfully:', response.data);
            onClose();
        } catch (err) {
            console.error('Event creation error:', err);
            console.error('Error response:', err.response);
            const errorMessage = err.response?.data?.message || err.message || 'Failed to create event';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <motion.div 
                className="modal-content" 
                onClick={e => e.stopPropagation()}
                initial={{ scale: 0.8, y: 100, opacity: 0 }}
                animate={{ scale: 1, y: 0, opacity: 1 }}
                transition={{ type: "spring", stiffness: 120, damping: 20 }}
                style={{ background: '#1c1c1e', border: '1px solid #333', borderRadius: '24px' }}
            >
                <h2 style={{ textAlign: 'center', marginTop: 0, fontSize: '1.5em', color: '#f0f0f0' }}>{t('create_new_vibe_title', { sportName: favoriteSportName })}</h2>
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <input type="text" name="title" value={formData.title} onChange={handleChange} required />
                    <input type="datetime-local" name="event_date" value={formData.event_date} onChange={handleChange} required />
                    <input type="number" name="max_participants" placeholder={t('max_players_placeholder')} min="2" onChange={handleChange} />
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', padding: '10px 0' }}>
                        <input type="checkbox" id="isPublic" checked={isPublic} onChange={() => setIsPublic(!isPublic)} style={{ width: '20px', height: '20px', accentColor: '#007BFF' }} />
                        <label htmlFor="isPublic" style={{ fontSize: '1.1em' }}>{t('open_for_everyone_label')}</label>
                    </div>
                    {error && <p style={{ color: '#ff4d4d', textAlign: 'center' }}>{error}</p>}
                    <button type="submit" disabled={loading} style={{ padding: '18px', borderRadius: '16px', border: 'none', backgroundColor: '#007BFF', color: 'white', fontSize: '1.2em', fontWeight: 'bold', cursor: 'pointer' }}>
                        {loading ? t('loading') : t('launch_vibe_button')}
                    </button>
                </form>
            </motion.div>
        </div>
    );
};

export default EventCreationModal;
